export const environment = {
  production: false,
  server: 'https://test.avs-api.com/commons/'
};
